<template>
  <div
    class="s-login-layout"
    :class="{ 's-login-layout--white': !isLoginPage }"
  >
    <div>
      <s-header
        v-if="!loading"
        :login="isLoginPage"
      />

      <div>
        <vis-loading
          size="md"
          v-if="loading"
        />
        <vis-error
          size="md"
          v-else-if="error"
          with-default
          :state="state"
        />
        <main
          v-else
          class="s-login-layout__main"
        >
          <section class="ba-w-full md:ba-w-auto ba-mt-10">
            <nav>
              <ul
                class="ba-flex ba-justify-center ba-select-none"
                :class="{ 'ba-text-white': isLoginPage }"
              >
                <li
                  v-for="(tab, index) in tabs"
                  :key="tab.routeName"
                  class="ba-text-2xl md:ba-text-3xlg ba-cursor-pointer ba-transition-all ba-duration-300 ba-ease-out"
                  :class="{
                    'ba-mr-8': index === 0,
                    'ba-opacity-20': $route.name !== tab.routeName,
                    'ba-pointer-events-none ba-font-medium': $route.name === tab.routeName
                  }"
                >
                  <router-link :to="{ name: tab.routeName, query: { state } }">
                    {{ tab.name }}
                  </router-link>
                </li>
              </ul>
            </nav>
            <transition
              name="s-login-layout"
              appear
            >
              <div class="ba-mt-8 md:ba-mt-15">
<!--                <div-->
<!--                  class="s-esia-form"-->
<!--                  :class="{'s-esia-form&#45;&#45;register': !isLoginPage}"-->
<!--                >-->
<!--                  <form-->
<!--                    :action="getEsiaProviderUrl()"-->
<!--                    method="POST"-->
<!--                    enctype="application/x-www-form-urlencoded"-->
<!--                  >-->
<!--                    <input-->
<!--                      type="hidden"-->
<!--                      name="state"-->
<!--                      :value="state"-->
<!--                    />-->
<!--                    <s-esia-button-->
<!--                      class="ba-mx-auto"-->
<!--                      :login="isLoginPage"-->
<!--                    />-->
<!--                  </form>-->
<!--                  <p class="s-esia-form__separator">или</p>-->
<!--                </div>-->
                <slot />
              </div>
            </transition>
          </section>
        </main>
      </div>
    </div>
  </div>
</template>

<script>
import { loginMixin } from "@ba/visary-account-common-vue";
// import SEsiaButton from "@/components/smena/s-esia-button";
import SHeader from "../../components/smena/s-header";

export default {
  name: "s-login-layout",
  components: {
    SHeader
    // SEsiaButton
  },
  mixins: [loginMixin],
  data() {
    return {
      tabs: [
        {
          name: "Вход",
          routeName: "login"
        },
        {
          name: "Регистрация",
          routeName: "register"
        }
      ]
    };
  },
  computed: {
    isLoginPage() {
      return this.$route.name === "login";
    }
  }
};
</script>
